import controller from './fillSubCase.controller';
import template from './fillSubCase.pug';

const FillSubCaseComponent = {
  template,
  controller,
  bindings: {
    subCase: '<',
  },
};

export default FillSubCaseComponent;



// WEBPACK FOOTER //
// ./client/app/cases/fillSubCase/fillSubCase.component.js